module.exports = __webpack_public_path__ + "static/odeniyi-3e607bb64dba169490a7481ceb0bdc2f.png";